import { normalizeTokens } from './normalizeTokens';
import { GridTemplateInputToken } from './types';

/**
 * Create a template string for the latest grid spec.
 *
 * @param tokens The tokens describing how the cells should be sized
 * @param count The number of cells in the row or column
 */
export function buildTemplate(tokens?: GridTemplateInputToken[], count?: number): string {
  const normalizedTokens = normalizeTokens(tokens);

  if (normalizedTokens.length) return normalizedTokens.map((t) => t.expandToken()).join(' ');
  if (count) return `repeat(${count}, 1fr)`;

  throw Error('You must supply either a template or count');
}
